<template>
  <section class="section get-in-touch-section">
    <div class="container items-center">
      <!--<h3 class="section__h3 mb-base">Get In Touch</h3>-->
      <!--<p class="section__p">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque luctus mi metus, egestas scelerisque orci ullamcorper eget. Fusce non congue erat. Nam pellentesque</p>-->
      <vs-row vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
        <vs-col vs-justify="center" vs-align="center" vs-w="6" vs-sm="12">
          <img class="contact-img" src="@/assets/images/aboutUs/contact-img.png" alt="contact-img">
        </vs-col>
        <vs-col class="items-left" vs-justify="center" vs-align="center" vs-w="5" vs-sm="12">
          
          <vs-card class="no-shadow-card py-5 items-left">
            <div class="items-left w-full">
            <h6 class="section__h6 mb-base">contact us</h6>
            <h3 class="section__h3 mb-base">Let's Collaborate Now!</h3>
          </div>
            <vs-row class="mb-5" vs-align="left" vs-type="flex" vs-justify="flex-start" vs-w="12">
              <vs-col class="text_area"  vs-type="flex" vs-justify="flex-start" vs-w="12">
                <label>Full Name</label>
                <!-- <vs-input id="test" no-border class="w-full input123" placeholder="Input Your Name" v-model="name" /> -->
                <div class="contact-us">
                  <vs-input
                  type="text"
                  placeholder="Input Your Name"
                    class="w-full newsletter-input vs-con-input"
                    v-model="input2"
                  />
                </div>
              </vs-col>
            </vs-row>
            <vs-row class="mb-5"  vs-type="flex" vs-justify="space-between" vs-w="12">
              <vs-col class="text_area" vs-type="flex" vs-justify="flex-start" vs-w="12">
                <label>Email</label>
                <!-- <vs-input class="w-full input" placeholder="Input Your Email" icon-no-border v-model="email" /> -->
                <!-- <vs-input style="background: aliceblue;" class="inputtest" size="default" placeholder="Size default" v-model="value2" /> -->
                <vx-input-group class="contact-us w-full">
                  <vs-input
                  type="email"
                  placeholder="Input Your Email"
                    class="newsletter-input"
                    v-model="input3"
                  />
                </vx-input-group>
              </vs-col>
              <!-- <vs-col class="text_area" vs-type="flex" vs-justify="end" vs-w="5">
                <label>Date</label>
                <vx-input-group class="contact-us w-full">
                  <vs-input
                  type="date"
                  icon-no-border
                    class="newsletter-input"
                    v-model="date"
                  />
                </vx-input-group>
              </vs-col> -->
            </vs-row>
            <vs-row class="mb-5" vs-type="flex" vs-justify="flex-start" vs-w="12">
              <vs-col class="text_area" vs-type="flex" vs-justify="flex-start" vs-w="12">
                <label for="textarea">Message</label>
                <vs-textarea id="textarea" class="w-full input" icon-no-border label="Write Message..." v-model="user_msg" height="100px" />
              </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-justify="center" vs-w="12">
              <vs-col vs-type="flex" vs-w="12">
                <vs-button class="mb-2 btn">Send Message</vs-button>
              </vs-col>
            </vs-row>
          </vs-card>
        </vs-col>
      </vs-row>
    </div>
  </section>
</template>

<script>

    export default {
        name: "GetInTouch",
        data(){
          return{
            input2: "",
            date: "",
            input3: "",
            user_msg: "",
          }
        }
    }
</script>

<style scoped>
input::placeholder{
  font-size: 20px;
}
 .input{
    background: #f5f5f5;
    border: 1px solid #f5f5f5!important;
    border-radius: 6px;
}
.inputtest {
  background: #d1d1d1!important;
}
.contact-us >>> input {
  background-color: #f5f5f5;
  border-color: #f5f5f5 !important;
}

.contact-us >>> i {
  color: #2c10e6 !important;
}
.contact-us::placeholder {
  font-size: 20px!important;
}

label {
  font-style: normal;
font-weight: 500;
font-size: 20px;
line-height: 32px;
color: #14183E;
}
  .items-center {
    text-align: center;
    text-align: -moz-center;
    text-align: -webkit-center;
  }
  .items-left {
    text-align: left;
    text-align: -moz-left;
    text-align: -webkit-left;
  }

  section {
    padding: 4rem 2rem 2rem 2rem;
    background: #FFFFFF;
  }

  section hr {
    height: 1px;
    width: 80%;
    color: #DDE6EF;
    opacity: 0.5;
  }

  button {
    border-radius: 50px!important;
  }
.section__h6 {
  font-style: normal;
font-weight: 600;
font-size: 14px;
line-height: 170%;
letter-spacing: 0.8px;
text-transform: uppercase;
color: #44CC88;
}
  .section__h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 28px;
    text-align: left;
    color: #231D4F;
  }
  .section__p {
    font-style: normal;
font-weight: bold;
font-size: 40px;
line-height: 140%;
color: #121127;
  }
  .truncate {
    width: 80%;
    white-space: normal !important;
    margin-left: 1.5rem;
  }
  .no-shadow-card {
    box-shadow: none;
  }
  .btn {
    padding: 20px 45px!important;
    background: linear-gradient(97.32deg, #FFC975 -3.47%, #F29300 108.43%)!important;
border: 2px solid rgba(255, 255, 255, 0.8);
box-shadow: 0px 30px 50px rgba(242, 147, 0, 0.2);
  }
  .text_area {
    flex-direction: column;
  }

  /*===============================================*/
  /* MEDIA QUERIES	 						 */
  /*===============================================*/

  @media (max-width: 1200px) {
    section {
      padding: 5rem 2rem;
      background: #FFFFFF;
    }
    .contact-img {
      height: 500px;
    }
  }
  @media (max-width: 760px) {
    .contact-img {
      height: 300px;
    }
    }
</style>
